// import axiosInstance from "@/utils/axiosInstance.js";

import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'

import * as authServices from '@/views/auth/auth-services.js'
import * as audienceServices from '@/views/audience/audience-services.js'
import * as sendersServices from '@/views/senders/senders-services.js'
import * as templateServices from '@/views/template/template-services.js'
import * as organizationServices from '@/views/organization/organization-services.js'
import * as userServices from '@/views/user/user-services.js'
import * as campaignServices from '@/views/campaign/campaign-services.js'
import * as transactionService from '@/views/transaction/transaction-services.js'
import * as backOfficeService from '@/views/backOffice/backoffice-services.js'
import * as plansSubscriptions from '@/views/plansSubscriptions/plansSubscriptions-services.js'
import * as automationServices from '@/views/automation/automation-services.js'
import * as faqsServices from '@/views/faqs/faqs-services.js'
import * as whitelabelServices from '@/views/whitelabel/whitelabel-services.js'
import * as twoWayMessaging from '@/views/twoWayMessaging/two-way-services.js'

let services = {}
//TODO ...XPTO.default n sei se isso é como se deve fazer mesmo

services = {
  getCurrentBalanceOrganization: (organizationId) => axiosInstance.get(`${SERVICES.BALANCE_TRANSACTIONS}/currentbalance/${organizationId}`),

  getBalancesOrganization: (targetOrganizationId, params) =>
    axiosInstance.get(`${SERVICES.BALANCES}/balances/${targetOrganizationId}/managebalance`, {
      params: params,
    }),

  getBillingInfo: (targetOrganizationId) => axiosInstance.get(`${SERVICES.ORGANIZATION}/${targetOrganizationId}/billinginfo`),

  getSmartInsight: (targetOrganizationId, webAreaId) => axiosInstance.get(`${SERVICES.USER_SMART_INSIGHT}/${targetOrganizationId}/${webAreaId}`),

  getPlans: (targetOrganizationId) => axiosInstance.get(`${SERVICES.BALANCES}/manageplans/${targetOrganizationId}`),

  //EMAIL
  postAddOnRecurrentEmail: async (organizationId, body) =>
    await axiosInstance.post(`${SERVICES.BALANCES}/addonrecurrentemail/${organizationId}/`, body),

  patchAddOnRecurrentEmail: async (organizationId, body) =>
    await axiosInstance.patch(`${SERVICES.BALANCES}/addonrecurrentemail/${organizationId}/`, body),

  deleteAddOnRecurrentEmail: async (organizationId, addOnOrganizationEmailId, params) =>
    await axiosInstance.delete(`${SERVICES.BALANCES}/addonrecurrentemail/${organizationId}/${addOnOrganizationEmailId}`, { params: params }),

  deleteBalanceEmail: async (organizationId, params) =>
    await axiosInstance.delete(`${SERVICES.BALANCES}/balances/${organizationId}/email`, { params: params }),

  withdrawBalanceEmail: async (organizationId, body) =>
    await axiosInstance.post(`${SERVICES.BALANCES}/balances/${organizationId}/currentbalance/email/withdraw`, body),
  addBalanceEmail: async (organizationId, body) =>
    await axiosInstance.post(`${SERVICES.BALANCES}/balances/${organizationId}/currentbalance/email/add`, body),

  //SMS
  postAddOnRecurrentSMS: async (organizationId, body) => await axiosInstance.post(`${SERVICES.BALANCES}/addonrecurrentsms/${organizationId}/`, body),

  patchAddOnRecurrentSMS: async (organizationId, body) =>
    await axiosInstance.patch(`${SERVICES.BALANCES}/addonrecurrentsms/${organizationId}/`, body),

  deleteAddOnRecurrentSMS: async (organizationId, addOnOrganizationEmailId, params) =>
    await axiosInstance.delete(`${SERVICES.BALANCES}/addonrecurrentsms/${organizationId}/${addOnOrganizationEmailId}`, { params: params }),

  deleteBalanceSMS: async (organizationId, countryId, params) =>
    await axiosInstance.delete(`${SERVICES.BALANCES}/balances/${organizationId}/sms/${countryId}`, { params: params }),

  addBalanceSMS: async (organizationId, body) =>
    await axiosInstance.post(`${SERVICES.BALANCES}/balances/${organizationId}/currentbalance/sms/add`, body),

  withdrawBalanceSMS: async (organizationId, body) =>
    await axiosInstance.post(`${SERVICES.BALANCES}/balances/${organizationId}/currentbalance/sms/withdraw`, body),
  withdrawBalaceSMS: async (organizationId, body) => await axiosInstance.path(`${SERVICES.BALANCES}/${organizationId}/sms/withdraw`, body),

  getPackAddons: async (addOn, params) => await axiosInstance.get(`${SERVICES.BALANCES}/${addOn}`, { params: params }),

  defaultCountryAddOnSms: async (organizationId) => await axiosInstance.get(`${SERVICES.BALANCES}/addonsms/${organizationId}/country`),

  getOrganizationPlan: async (organizationId) => await axiosInstance.get(`${SERVICES.BALANCE_ORGANIZATION_PLANS}/${organizationId}`),

  getOrganizationPlanFeatures: async (organizationId) => await axiosInstance.get(`${SERVICES.BALANCE_ORGANIZATION_PLANS}/${organizationId}/features`),

  //PAYMENT
  validatebillinginfo: async ($organizationId, $data) =>
    await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/validatebillinginfo`, $data),

  createpaymentintent: async ($organizationId, $data) =>
    await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/createpaymentintent`, $data),

  balancetax: async ($organizationId, $data) => await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT_ADDON}/${$organizationId}/tax`, $data),

  confirmpaymentintent: async ($organizationId, $data) =>
    await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/ConfirmPaymentIntent`, $data),

  stripePaymentIntentId: async ($organizationId, $stripePaymentIntentId) =>
    await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/paymentintent${$stripePaymentIntentId}`),

  getPaymentIdClientSecret: async ($organizationId, $paymentId) =>
    await axiosInstance.get(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/${$paymentId}/clientsecret`),

  //GET DATA TABLES
  getDataTables: async ($microServiceName, $resouce, $organizationId, $filters) =>
    await axiosInstance.post(`${SERVICES[$microServiceName]}/${$organizationId}/${$resouce}`, $filters),

  ...authServices.default,
  ...audienceServices.default,
  ...sendersServices.default,
  ...templateServices.default,
  ...campaignServices.default,
  ...userServices.default,
  ...organizationServices.default,
  ...transactionService.default,
  ...backOfficeService.default,
  ...plansSubscriptions.default,
  ...automationServices.default,
  ...faqsServices.default,
  ...whitelabelServices.default,
  ...twoWayMessaging.default
}

export default services
